import { makeStyles } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { moveNextPage, updateCreatorOnboarding } from "../../../../../store/actions/creator/creatorOnBoarding";
import UtilService from "../../../../../helper/service";
import { useHistory, useLocation } from "react-router";
import OnboardingBtn from "../../../../atoms/creator/onboardingEnterBtn";

const useStyles = makeStyles(() => ({
  title: {
    textAlign: 'center',
    fontSize: 36,
    color: '#212D40',
    fontFamily: 'Spartan-bold',
    lineHeight: 1.25,
    marginTop: 10,
    marginBottom: 10,
    '@media (max-width: 600px)': {
      fontSize: '25px!important',
      marginTop: 6,
    },
  },
  videoplayer: {
    width: '60vw',
    '@media (max-width: 600px)': {
      width: '80vw',
    },
  },
  boxcenter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  description: {
    marginTop: 20,
    marginBottom: -20,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& p': {
      maxWidth: 1000,
      margin: 0,
      fontFamily: 'roboto-light',
      fontSize: (props: any) => (props.height < 770 || props.width < 1520) ? 20 : 24,
      color: '#212D40',
      textAlign: 'center',
      lineHeight: 1.25,
      '@media (max-width: 600px)': {
        fontSize: '15px!important',
      },
    }
  },
  imgDiv: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '@media (max-width: 600px)': {
      width: 390,
      height: 200
    },
    '@media (max-width: 400px)': {
      width: 320,
      height: 180
    },
  },
  img: {
    width: (props: any) => props.height < 770 ? 700 : 900,
    height: 'auto',
    '@media (max-width: 600px)': {
      width: '390px!important',
      height: 200
    },
    '@media (max-width: 400px)': {
      width: '320px!important',
      height: 180
    },
  }
}));

const Module1Slide6 = () => {

  const size = UtilService.useWindowSize();
  const classes = useStyles(size);
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const { userPreferences } = useSelector((state: any) => state.creatorOnBoarding);
  const { activepage } = userPreferences;
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : "";

  useEffect(() => {
    window.addEventListener('keydown', handleUserKeyPress);
    return () => {
      window.removeEventListener('keydown', handleUserKeyPress);
    };
  });

  useEffect(() => {
    UtilService.addHashTag(history, location.pathname, 'm1s6');
  }, []);

  const handleUserKeyPress = (event: any) => {
    if (event.keyCode === 13) {
      goNext();
    }
  };

  const goNext = () => {
    const request = {
      user_id: loginUserData.user_id,
      preference_id: userPreferences.module1s6.id,
      preference_name: 'MODULE1S6',
      preference_information: 'true',
    };
    dispatch(updateCreatorOnboarding(apolloClient.client, request));

    if (Number(activepage.value) < 8) {
      const reqActivePage = {
        user_id: loginUserData.user_id,
        preference_id: userPreferences.activepage.id,
        preference_name: 'ACTIVEPAGE',
        preference_information: '8',
      };
      dispatch(updateCreatorOnboarding(apolloClient.client, reqActivePage));
    }

    dispatch(moveNextPage(8))
  };

  const goBack = () => {
    dispatch(moveNextPage(6))
  };

  return (
    <div>
      <div className={classes.title}>
        You can see your results come in live, in real-time…
      </div>
      <div className={classes.boxcenter}>
        <video className={classes.videoplayer} autoPlay loop>
          <source src="/assets/video/meeting-laptop-v2.mp4" type="video/mp4"/>
          <img className={classes.img} src={'/assets/icons/onboarding/module1-slide6.gif'} alt={'Realtime Data'} />
        </video>
      </div>

      <div className={classes.description}>
        <p>
          And once the Experience is completed, the fun starts! Identify which parts of the experience
          landed well and which fell flat. This can guide editing, help you pick which version will connect
          most deeply with your audience, and find or unlock new market segments.
        </p>
      </div>

      <OnboardingBtn goNext={goNext} goBack={goBack} title={'Got It'} isRight />
    </div>
  )
};

export default Module1Slide6;